var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "article-accordion-collapsible" },
    [
      _c(
        "div",
        {
          class: [
            "position-relative",
            {
              "expand-all": !_vm.isAllExpanded(),
              "collapse-all": _vm.isAllExpanded()
            }
          ]
        },
        [
          _c(
            "a",
            {
              on: {
                click: function($event) {
                  return _vm.toggleAll()
                }
              }
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.isAllExpanded() ? "Alle schließen" : "Alle öffnen"
                  ) +
                  "\n        "
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.articleAccordionData["content_list_repeater"], function(
        listItem,
        listItemIndex
      ) {
        return _c(
          "div",
          {
            key: listItemIndex,
            class: [
              "accordion-item",
              "accordion-item-" + listItemIndex,
              { active: _vm.activeAccordions.includes(listItemIndex) }
            ]
          },
          [
            listItem["list_content_headline"]
              ? _c(
                  "h1",
                  {
                    staticClass: "list-headline",
                    on: {
                      click: function($event) {
                        return _vm.toggleAccordion(listItemIndex)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(listItem["list_content_headline"]) +
                        "\n        "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(listItem["list_content_composer_collapsible"], function(
              listContent,
              listContentIndex
            ) {
              return listItem["list_content_composer_collapsible"]
                ? _c(
                    "div",
                    {
                      key: listItemIndex + "-" + listContentIndex,
                      class: [
                        "accordion-content",
                        { active: _vm.activeAccordions.includes(listItemIndex) }
                      ]
                    },
                    [
                      listContent["acf_fc_layout"] ===
                      "list_content_composer_subline_h2"
                        ? _c(
                            "h2",
                            {
                              staticClass: "list-content-subline",
                              attrs: {
                                "data-accordion-list-item-index": listItemIndex,
                                "data-accordion-list-content-index": listContentIndex
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    listContent["list_content_subline_h2"]
                                  ) +
                                  "\n                "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      listContent["acf_fc_layout"] ===
                      "list_content_composer_subline_h3"
                        ? _c("h3", { staticClass: "list-content-subline" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(listContent["list_content_subline_h3"]) +
                                "\n                "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      listContent["acf_fc_layout"] ===
                      "list_content_composer_paragraph"
                        ? _c(
                            "div",
                            [
                              listContent["list_content_copy_image"] &&
                              listContent[
                                "list_content_copy_image_position"
                              ] === "below"
                                ? [
                                    _c("div", {
                                      staticClass: "list-content-copy-body",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          listContent["list_content_copy_body"]
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "list-content-image-container"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "list-content-image" },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src:
                                                  listContent[
                                                    "list_content_copy_image"
                                                  ],
                                                alt: ""
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                : listContent["list_content_copy_image"] &&
                                  listContent[
                                    "list_content_copy_image_position"
                                  ] === "left"
                                ? _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "list-content-image-container col col-12",
                                        class: {
                                          "col-md-4":
                                            listContent[
                                              "list_content_copy_image_size"
                                            ] === "1/3",
                                          "col-md-6":
                                            listContent[
                                              "list_content_copy_image_size"
                                            ] === "1/2"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "list-content-image" },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src:
                                                  listContent[
                                                    "list_content_copy_image"
                                                  ],
                                                alt: ""
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "list-content-copy-body",
                                      class: {
                                        "col-md-8":
                                          listContent[
                                            "list_content_copy_image_size"
                                          ] === "1/3",
                                        "col-md-6":
                                          listContent[
                                            "list_content_copy_image_size"
                                          ] === "1/2"
                                      },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          listContent["list_content_copy_body"]
                                        )
                                      }
                                    })
                                  ])
                                : listContent["list_content_copy_image"] &&
                                  listContent[
                                    "list_content_copy_image_position"
                                  ] === "right"
                                ? _c("div", { staticClass: "row" }, [
                                    _c("div", {
                                      staticClass: "list-content-copy-body",
                                      class: {
                                        "col-md-8":
                                          listContent[
                                            "list_content_copy_image_size"
                                          ] === "1/3",
                                        "col-md-6":
                                          listContent[
                                            "list_content_copy_image_size"
                                          ] === "1/2"
                                      },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          listContent["list_content_copy_body"]
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "list-content-image-container",
                                        class: {
                                          "col-md-4":
                                            listContent[
                                              "list_content_copy_image_size"
                                            ] === "1/3",
                                          "col-md-6":
                                            listContent[
                                              "list_content_copy_image_size"
                                            ] === "1/2"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "list-content-image" },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src:
                                                  listContent[
                                                    "list_content_copy_image"
                                                  ],
                                                alt: ""
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                : _c("div", {
                                    staticClass: "list-content-copy-body",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        listContent["list_content_copy_body"]
                                      )
                                    }
                                  })
                            ],
                            2
                          )
                        : _vm._e()
                    ]
                  )
                : _vm._e()
            })
          ],
          2
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00f9478d", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00f9478d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/ArticleAccordionCollapsible.vue
// module id = 568
// module chunks = 0